import { memo } from 'react'

import { ListToolbar } from '@mangovoice/mango-ui'
import type { ListToolbarProps } from '@mangovoice/mango-ui'

import type { SwitchboardTranslateFn } from '../../types'

export interface SwitchboardListToolbarProps extends Omit<
  ListToolbarProps,
  't' | 'i18nPrefix'
> {
  /** Optional translation function for i18n */
  t?: SwitchboardTranslateFn
}

/**
 * Switchboard-specific wrapper around the shared ListToolbar.
 * Preserves the existing public API while delegating to @mangovoice/mango-ui.
 */
export const SwitchboardListToolbar = memo<SwitchboardListToolbarProps>(
  (props) => {
    return <ListToolbar {...props} i18nPrefix="switchboard.list.pagination" />
  },
)

SwitchboardListToolbar.displayName = 'SwitchboardListToolbar'
